module.exports = __webpack_public_path__ + "img/right-bottom-logo.ccc2dbbd.png";